// Expression-editor config for MATCH mappings: the field catalog (Adopets + each
// partner) the JsExpressionEditor offers, keyed by side. Shared by Color/Branch
// via the `ExpressionField` component.

import { COMPARISON_OPERATORS, EQUALITY_OPERATORS, ExpressionEditorConfig, FieldConfig, LabelValue } from "components/JsExpressionEditor";
import { PetAgeKey, PetColorKey, PetSexKey, PetSizeKey } from "./enums";
import { PartnerKeyType } from "interfaces/IIntegration";

const baseConfig: ExpressionEditorConfig = {
    operators: COMPARISON_OPERATORS,
    fields: []
}

export const getJsExpressionConfig = (params?: {
    fields?: Partial<Record<"ADOPETS" | PartnerKeyType, boolean>>
}) => {
    const fields: FieldConfig[] = []
    Object.entries(params?.fields || {}).forEach(([key, value]) => {
        if (value) {
            fields.push(...(PARTNER_FIELDS[key] ?? []))
        }
    })

    return Object.assign({}, baseConfig, { fields })
}

// ----------------------------------------------------------------------------
// FIELDS
// ----------------------------------------------------------------------------

enum FieldGroup {
    ADOPETS = "Adopets Pet",
    SHELTER_BUDDY = "External Pet - ShelterBuddy"
}

// Adopets Fields
const enumToLabelValue = (obj: Record<string, string>): LabelValue[] => Object.entries(obj).map(v => ({ label: v[0], value: v[1] }))

const COLOR_OPTIONS = enumToLabelValue(PetColorKey).sort((a, b) => a.label.localeCompare(b.label))
const SIZE_OPTIONS = enumToLabelValue(PetSizeKey)
const GENDER_OPTIONS = enumToLabelValue(PetSexKey)
const AGE_OPTIONS = enumToLabelValue(PetAgeKey)

const ADOPETS_FIELDS: FieldConfig[] = [
    { group: FieldGroup.ADOPETS, label: 'Primary color', value: '$ctx.pet.attrs.primary_color_key', options: COLOR_OPTIONS, operators: EQUALITY_OPERATORS },
    { group: FieldGroup.ADOPETS, label: 'Secondary color', value: '$ctx.pet.attrs.secondary_color_key', options: COLOR_OPTIONS, operators: EQUALITY_OPERATORS },
    { group: FieldGroup.ADOPETS, label: 'Size', value: '$ctx.pet.size_key', options: SIZE_OPTIONS, operators: EQUALITY_OPERATORS },
    { group: FieldGroup.ADOPETS, label: 'Gender', value: '$ctx.pet.sex_key', options: GENDER_OPTIONS, operators: EQUALITY_OPERATORS },
    { group: FieldGroup.ADOPETS, label: 'Age', value: '$ctx.pet.age_key', options: AGE_OPTIONS, operators: EQUALITY_OPERATORS },
]

// Partner Fields
const SHELTER_BUDDY_FIELDS: FieldConfig[] = [
    { group: FieldGroup.SHELTER_BUDDY, label: "Physical Location ID", value: "$ctx.ipet.json.external_data.Location.PhysicalLocation?.Id.toString()", operators: EQUALITY_OPERATORS },
    { group: FieldGroup.SHELTER_BUDDY, label: "Physical Location Name", value: "$ctx.ipet.json.external_data.Location.PhysicalLocation?.Name", operators: EQUALITY_OPERATORS },
]

// ----------------------------------------------------------------------------

const PARTNER_FIELDS: Partial<Record<"ADOPETS" | PartnerKeyType, FieldConfig[]>> = {
    ADOPETS: ADOPETS_FIELDS,
    SHELTER_BUDDY: SHELTER_BUDDY_FIELDS,
}
